<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>{{ message }}</mat-dialog-content>
<mat-dialog-actions>
    <button *ngFor="let choice of choices"
            mat-button
            color="primary"
            (click)="onClick(choice)">{{ choice }}</button>
</mat-dialog-actions>